<header class="header-container">
  <mat-toolbar>
    <span class="brand">
      <img [src]="headerContent.image?.url" [alt]="headerContent.image?.ariaLabel" class="brand-logo">
    </span>
    <span class="spacer"></span>
    <section class="menu-detail">
      @if(isMobile) {
      <span class="menu-icon">
        <svg-icon name="hamburg" mat-flat-button [matMenuTriggerFor]="menu"> </svg-icon>
        <mat-menu #menu="matMenu">
          @for(link of headerContent.links; track $index;){
          <a mat-menu-item [id]="'link'+($index+1)" [href]="link.url" target="_blank" class="text-link">
            <div [innerHTML]="link.label"></div>
          </a>
          }
        </mat-menu>
      </span>
      }
      @else {
      <section class="menu">
        @for(link of headerContent.links; track $index; let last = $last){
        <a mat-menu-item [id]="'link'+($index + 1)" [href]="link.url" target="_blank" class="text-link">
          <div [innerHTML]="link.label"></div>
        </a>
          @if(!last) {
            <span class="link-divider"> | </span>
          }
        }

      </section>
      }
    </section>
  </mat-toolbar>
</header>